import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { sgNbAdditionChartConfig } from '../chartConfigs';

/**
 * Props for the SgNbAdditionEcharts component
 */
interface SgNbAdditionEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * SgNB Addition Success Rate Chart (LTE Site Level)
 * 
 * Displays Secondary gNodeB (SgNB) addition metrics for EN-DC:
 * - SgNB Addition Success (count)
 * - SgNB Addition Attempt (count)
 * - SgNB Addition Success Rate (percentage)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (sgNbAdditionChartConfig)
 * @see API: /api/lte/sgnb-addition?site_name={siteName}
 */

const SgNbAdditionEcharts: React.FC<SgNbAdditionEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={sgNbAdditionChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default SgNbAdditionEcharts;
